import ConsentPage from "./ConsentPage";

export default ConsentPage;
